<template>
  <el-dialog
    title="Ra trường – Nhân sự"
    :visible.sync="dialogVisible"
    width="560px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-s-promotion"></i></div>
          <div>
            <p class="sk-panel-title">Chọn trạng thái ra trường</p>
            <p class="sk-panel-subtitle">Xác nhận trạng thái và ngày ra trường của các nhân viên đã chọn.</p>
          </div>
        </div>
        <el-form label-width="130px">
          <el-form-item label="Trạng thái">
            <el-select
              style="width: 100%"
              v-model="dataSearch.idGroupOut"
              placeholder="Chọn trạng thái"
            >
              <el-option
                v-for="item in employeeStatusList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Ngày ra trường">
            <el-date-picker
              style="width: 100%"
              v-model="dataSearch.dateOut"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              format="dd-MM-yyyy"
              placeholder="Chọn ngày ra trường"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close" />
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
        class="btn-save"
        type="success"
        size="medium"
        :loading="loadingButton"
        @click="submitForm()"
      >
        <i class="el-icon-circle-check" />
        <span>{{ $t("button.save") }}</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import GroupOutService from "@/services/GroupOutService";
import moment from "moment";

export default {
  props: {
    dialogVisible: null,
    listEmployee: null,
  },
  data() {
    return {
      loadingButton: false,
      employeeStatusList: [],
      dataSearch: {
        idGroupOut: "",
        name: "",
        dateOut: moment().format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dataSearch.dateOut = moment().format("YYYY-MM-DD");
      }, 500);
    },
    //click when click button
    closeDialogByButton() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dataSearch.dateOut = moment().format("YYYY-MM-DD");
      }, 500);
    },
    submitForm() {
      this.loadingButton = true;
      let data = {
        idList: this.$props.listEmployee.map((x) => x.id),
        idGroupOut: this.dataSearch.idGroupOut,
        dateOut: this.dataSearch.dateOut,
      };
      GroupOutService.updateEmployeeGroupOut(data)
        .then((resp) => {
          this.$message({
            message: resp.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.closeDialog();
          }, 500);
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingButton = false;
          }, 500);
        });
    },
    async getAllGroupOutEmployeeName() {
      await GroupOutService.getAllGroupOutEmployeeNameEmployee()
        .then((resp) => {
          this.employeeStatusList = resp.data.data;
          if (this.employeeStatusList.length > 0) {
            this.dataSearch.name = this.employeeStatusList[0].name;
            this.dataSearch.idGroupOut = this.employeeStatusList[0].id;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeMount() {
    this.getAllGroupOutEmployeeName();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
